export default "__VITE_ASSET__Bv$hsMzI__"